export const DATE_PICKER_INPUT_CATEGORY_KEY = 'base' as const;
export const DATE_PICKER_INPUT_PARENT_COMPONENT_KEY = 'datePicker' as const;
export const DATE_PICKER_INPUT_COMPONENT_KEY = 'datePickerInput' as const;
